import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private requestService: RequestService) { }

  /**  Add or Remove an asset from My List 
   * @param asset Asset
  */
  toggleList(asset) {
    return new Promise(resolve => {
      if (asset.inList) {
        this.removeList([asset.id]).then((resp: any) => {
          resolve(this.setUpButton(false));
        });
      } else {
        this.addList(asset.id).then((resp: any) => {
          resolve(this.setUpButton(true));
        });
      }
    });
  }

  /**  Return the proper button for my list
  * @param flag Boolean
  * @returns Object {id,icon,title}
  */
  setUpButton(flag) {
    return {
      id: "myList",
      icon: flag ? "fa fa-minus" : "fa fa-plus",
      title: "gen_my_list"
    }
  }

  /**  Add an asset to My List
  * @param assetId Id of an asset 
  */
  addList(assetId) {
    let req = {
      url: "/api/personalizedContent/addMyList",
      req: {
        assetId: assetId,
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  /** Remove a list of assets to My List
  * @param assetIds Array of Assets ids
  */
  removeList(assetIds) {
    let req = {
      url: "/api/personalizedContent/deleteMyList",
      req: {
        assetsIds: assetIds
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  /** Get My List
  * @param count: Number - Count *Optional - Default 20
  * @param offset: Number - Offset *Optional - Default 0
  * @returns assets: Array - of assets
  */
  getList(params) {
    let req = {
      url: "/api/personalizedContent/getMyList",
      req: {
        count: params.count ? params.count : 20,
        offset: params.offset ? params.offset : 0
      }
    };
    return this.requestService.mainPostRequest(req);
  }
}